import React from "react";
import { Heart, Search, Users, Gift } from "lucide-react";

/** Buddy Bookings — scheduled picking sessions for pairs, three pairs per session. */
export function BuddyBookings({ buddy, onFind }) {
  if (!buddy) return null;
  const upcoming = (buddy.sessions || []).filter((s) => s.status === "available");
  return (
    <section data-testid="buddy-bookings" className="relative overflow-hidden bg-[var(--berry-deep)] text-white border-y-[3px] border-[var(--berry)]">
      <div className="max-w-6xl mx-auto px-5 md:px-8 py-12 md:py-16 grid gap-8 lg:grid-cols-[1.2fr_0.8fr] items-center">
        <div>
          <span className="inline-flex items-center gap-2 px-4 py-1.5 wobble-pill bg-white/10 font-display tracking-[0.35em] text-xs">
            <Heart className="w-3.5 h-3.5" /> MADE FOR TWO
          </span>
          <h2 className="font-display text-4xl md:text-5xl mt-5 leading-[1.05]">{buddy.title}</h2>
          <p className="mt-5 text-lg md:text-xl leading-relaxed text-white/90" data-testid="buddy-lead">{buddy.lead}</p>
          <p className="mt-4 text-lg leading-relaxed text-white/85" data-testid="buddy-body">{buddy.body}</p>
          <p className="mt-5 font-display-italic text-2xl md:text-3xl text-[#F4D06F]" data-testid="buddy-price-line">{buddy.price_line}</p>
          <button type="button" onClick={onFind} data-testid="buddy-find-btn"
            className="mt-7 inline-flex items-center gap-2 h-14 px-7 wobble-pill bg-white text-[var(--berry-deep)] font-display text-lg hover:bg-[#F4D06F] transition-colors">
            <Search className="w-5 h-5" /> Find a Buddy Booking
          </button>
        </div>
        <div className="bg-white/10 border border-white/25 p-6 space-y-4 wobble-b">
          <div className="font-label tracking-[0.4em] text-[10px] text-[#F4D06F]">✦ HOW IT WORKS ✦</div>
          <ul className="space-y-2.5 text-base text-white/90">
            <li className="flex items-start gap-2.5"><Users className="w-5 h-5 mt-0.5 shrink-0 text-[#F4D06F]" /> {buddy.schedule}</li>
            <li className="flex items-start gap-2.5"><Heart className="w-5 h-5 mt-0.5 shrink-0 text-[#F4D06F]" /> NZ${Number(buddy.price).toFixed(0)} per pair — not per person. Up to {buddy.max_pairs} pairs share a session, each with their own picking area.</li>
            <li className="flex items-start gap-2.5"><Gift className="w-5 h-5 mt-0.5 shrink-0 text-[#F4D06F]" /> {buddy.over_75_copy}</li>
          </ul>
          <div className="border-t border-white/20 pt-3 text-sm text-white/80" data-testid="buddy-upcoming">
            {upcoming.length === 0 ? "No Buddy dates with places left right now — check back soon." : (
              <>Next dates with pair places: {upcoming.slice(0, 4).map((s) => `${new Date(`${s.date}T12:00:00`).toLocaleDateString("en-NZ", { weekday: "short", day: "numeric", month: "short" })} (${s.remaining} left)`).join(" · ")}</>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
